export const PATS_NAMES_ROUTES = {
    classification: 'classification',
    tagging: 'settings',
    management: 'analyze_debug',
    configurationPage: 'configuration',
    faceRecognition: 'face_recognition',
    dataManagement: 'data_projects'
};

